export function mergeConfigs(config1, config2) {
    const keys1 = Object.keys(config1);
    const keys2 = Object.keys(config2);
    const sameKeys = keys1.filter(key => keys2.includes(key) && typeof config1[key] === 'object' && typeof config2[key] === 'object');
    const mergedObjects = {};
    sameKeys.forEach(key => {
        mergedObjects[key] = mergeConfigs(config1[key], config2[key]);
    });
    return { ...config1, ...config2, ...mergedObjects };
}
